// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J4eRWTnBY8VkWrZ8MrZA{flex-grow:1;margin-left:16px;display:flex;position:relative}.dpngePt65eMlT1xDS3lj{align-items:center;gap:10px;width:100%;min-width:0;display:flex}.dpngePt65eMlT1xDS3lj :has(.ToHJTYa2iUcrw_7fhY5t){min-width:0}.Gy74853o2Swo6cp5LX2J{flex:none;margin-left:auto;margin-right:8px}.ToHJTYa2iUcrw_7fhY5t{margin-left:2px}.z7O_sfAhph4fUnBSFarj{color:var(--blue-50);padding:0}.EGl7aWRkmg_ErA5uiAjp{word-break:break-word}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `J4eRWTnBY8VkWrZ8MrZA`,
	"nameCell": `dpngePt65eMlT1xDS3lj`,
	"triggerName": `ToHJTYa2iUcrw_7fhY5t`,
	"nameToggle": `Gy74853o2Swo6cp5LX2J`,
	"reconnectButton": `z7O_sfAhph4fUnBSFarj`,
	"tooltipText": `EGl7aWRkmg_ErA5uiAjp`
};
export default ___CSS_LOADER_EXPORT___;
